<template>
  <div v-if="!IsMcfs" class="surplus-returns-totals-component srtc left-menu">
    <b-row class="no-gutters">
      <b-col class="nav-sub pb-0">
        <h4>Surplus Return Totals</h4>
        <div class="srtc__claims-order-search-body">
          <p>
            Allocated amount remaining for {{ user.DealerCode }} as of {{ startDate }} - {{ endDate }}
          </p>

          <dl class="srtc__returns-totals"
            v-for="(item, index) in surplusReturnTotals"
            :key="index"
          >
            <dt class="srtc__totals-list-title">{{ item.label }}</dt>
            <dd class="srtc__totals-list-item">
              <currency-text :amount="item.value" />
            </dd>
          </dl>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import { ReturnsService } from "@/services/ReturnsService"
  import CurrencyText from "@/components/Elements/CurrencyText"
  import { fiscalYearMixin } from "@/components/mixins/fiscalYearMixin"
  import { formatDateTime } from "@/components/mixins/formatDateTime"
  import moment from "moment"

  export default {
    components: { CurrencyText },
    mixins: [fiscalYearMixin, formatDateTime],
    data: () => ({
      surplusReturnTotals: [],
    }),
    computed: {
      ...mapGetters(["getContentItem", "activeAccountId", "user", "activeAccountId", "IsMcfe", "IsMcfs"]),
      startDate()
      {
        if (this.IsMcfe)
        {         
          return this.formatDateTime(moment().startOf("year"));
        }
        else 
        {
          return this.formatDateTime(this.fiscalYear.startDate);
        }
      },

      endDate()
      {
        if (this.IsMcfe)
        {
          return this.formatDateTime(moment().endOf("year"));
        }
        else
        {
          return this.formatDateTime(this.fiscalYear.endDate);
        }
      }
    },
    mounted () {
      this.getSurplusReturnTotals()
    },
    methods: {
      getSurplusReturnTotals () {
        ReturnsService.GetSurplusAuthorizedAmounts(this.activeAccountId, this.user.UserId).then(result => {
          this.surplusReturnTotals = result
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
 .surplus-returns-totals-component {
    padding: 10px 0px;
    background-color: #fff;
  }

  .srtc__claims-order-search-body {
  padding: 10px 7px;
  
  }

   .srtc__totals-list{
    background-color: #d2def1;
  }

  .srtc__returns-totals {
    line-height: 28px;
  }

  .srtc__totals-list-item {
    font-size: 24px;
    font-weight: bold;
    color: $blue;
  }

  .srtc__totals-list-title{
    font-size: 20px;
  }



</style>
